export class UserContext {
  private _id: number;
  private email?: string;
  private _assignedRoles?: number[];
  private _assignedClasses?: number[];
  private _coordinatedClasses?: number[];
  private _childrenIds?: number[];

  constructor() {
    this._id = 0;
  }

  public get id(): number {
    return this._id;
  }

  public set id(userId: number) {
    this._id = userId;
  }

  public get assignedRoles(): number[] | undefined {
    return this._assignedRoles;
  }

  public set assignedRoles(roles: number[] | undefined) {
    this._assignedRoles = roles;
  }

  public get assignedClasses(): number[] | undefined {
    return this._assignedClasses;
  }

  public set assignedClasses(classes: number[] | undefined) {
    this._assignedClasses = classes;
  }

  public get coordinatedClasses(): number[] | undefined {
    return this._coordinatedClasses;
  }

  public set coordinatedClasses(classes: number[] | undefined) {
    this._coordinatedClasses = classes;
  }

  public get childrenIds(): number[] | undefined {
    return this._childrenIds;
  }

  public set childrenIds(childrenIds: number[] | undefined) {
    this._childrenIds = childrenIds;
  }
}
